import TriggersLogsPage from './TriggersLogsPage';

export default TriggersLogsPage;